import EditOutlinedIcon from '@mui/icons-material/EditOutlined'

import CustomIconButton from '@/components/inputs/CustomIconButton'

type EditIconButtonProps = {
  onClick?: () => void
  tooltipText?: string
}

function EditIconButton({ onClick, tooltipText }: Readonly<EditIconButtonProps>) {
  return (
    <CustomIconButton
      Icon={EditOutlinedIcon}
      color="primary"
      iconProps={{
        titleAccess: tooltipText,
      }}
      size="medium"
      tooltipProps={{
        title: tooltipText,
        placement: 'top',
      }}
      onClick={onClick}
    />
  )
}

export default EditIconButton
